// src/hooks/usePerformanceAnalytics.js
import { useState, useEffect, useCallback } from 'react';
import { auth } from '../firebase';

const FUNCTION_URL = 'https://us-central1-winnepocket-landscaping.cloudfunctions.net/getGCPMetrics';

const usePerformanceAnalytics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMetrics = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const token = await auth.currentUser?.getIdToken();
      if (!token) throw new Error('Not authenticated');

      const response = await fetch(FUNCTION_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      });

      const json = await response.json();
      if (!response.ok) throw new Error(json.error || `Server error ${response.status}`);
      setData(json);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return { data, loading, error, refresh: fetchMetrics };
};

export default usePerformanceAnalytics;